const Theme = {
  body_background_color: '#bdd2e9',

  logo_image_url: 'villebonaventure.png',
  logo_height: 120,

  token_url: 'villebonaventure.png',
  token_width: 60,
  number_hidden: true,

  title_font: `'Varela Round', sans-serif`,
  title_size: 31,
  title_lineheight: 38.8,
  title_color: '#333333',

  subtitle_size: 24,
  subtitle_lineheight: 31.8,

  text_font: `'Varela Round', sans-serif`,
  text_size: 15,
  text_lineheight: 24,
  text_color: '#666666',

  button_color: '#ffd800',
  button_text_color: '#0b5896',
  button_hover_color: '#ABAE51',
  button_hover_text_color: 'white',
  button_no_border: true,
  button_outlined_color: '#0b5896',
  button_outlined_text_color: '#ffd800',
  button_outlined_hover_color: '#ffd800',
  button_outlined_hover_text_color: '#0b5896',

  button_half_border_color: '#EAEAEA',

  footer_text_color: '#666666',
}

export default Theme
